module.exports = __webpack_public_path__ + "assets/images/slope-size/mobile.svg?v=6665dd9a";